<template>
  <div class="form-submit">
    <mt-button
      type="primary"
      size="small"
      :class="{ 'radius': facadeArr.indexOf('radius') >= 0 }"
      @click="submit"
    >{{ text || '保存' }}</mt-button>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import regex from '@/utils/regex'

export default {
  name: 'FormSubmit',
  props: {
    text: {
      type: String,
      default: ''
    },
    // 按钮场景（颜色）
    type: {
      type: String,
      default: ''
    },
    // 外观
    facade: {
      type: [String, Array],
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    rules: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    form() {
      let parent = this.$parent
      if (parent == null) return null
      let options = parent.$options
      let parentName = options && options.componentName
      while (parentName !== 'FormEntity') {
        parent = parent.$parent
        if (parent == null) return null
        options = parent.$options
        parentName = options.componentName
      }
      return parent
    },
    fieldItems() {
      const form = this.form
      if (form) {
        return form.$children.filter(c => {
          return c.$options.componentName === 'FormField'
        })
      }
      return null
    },
    facadeArr() {
      const { facade } = this
      return facade instanceof Array ? facade : facade ? [facade] : []
    }
  },
  methods: {
    submit() {
      const errors = this.validateForm()
      if (errors && errors.length) {
        Toast(errors[0])
        return
      }
      this.$emit('submit')
    },
    validateForm() {
      const form = this.form
      // 单独使用的按钮
      if (form == null) {
        return null
      }
      const errors = []
      if (form && form.model) {
        const rules = form.rules
        this.fieldItems.forEach(field => {
          const prop = field.prop
          const value = form.model[prop]
          // 自定义验证函数
          const rule = rules[prop]
          const label = this.getError(value, prop, { rule })
          if (label) {
            errors.push(label)
          }
        })
      }
      // show(errors)
      this.$log.debug(errors)
      return errors
    },
    getError(value, prop, { rule }) {
      let status = null
      let notEmpty = null
      const field = this.fieldItems.find(f => f.prop === prop)
      const options = field.options
      if (options.required) {
        notEmpty = Boolean(value)
        status = notEmpty
      }
      // 已填写后验证rule
      if (status) {
        if (rule) {
          status = rule(value)
        } else if (options.format === 'phone') {
          status = regex.isMobilephone(value)
        } else if (options.format === 'idcard') {
          status = regex.IsIDNumber(value)
        } else if (options.format === 'bankno') {
          status = regex.IsBankNo(value)
        }
      }
      // 获取提示信息
      if (typeof status === 'string') {
        return status
      }
      if (status === false) {
        let label = ''
        if (['text', 'textarea'].indexOf(field.type) >= 0) {
          label = notEmpty ? '请正确填写' : '请填写'
        } else {
          label = '请选择'
        }
        label += (field.label || '')
        return label
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-submit {
  margin: .48rem;
  display: flex;
  .mint-button {
    width: 100%;
    &.mint-button--small {
      height: .88rem;
      line-height: .88rem;
      font-size: .32rem;
    }
    &.radius {
      border-radius: .12rem;
      width: 80%;
      margin: auto;
    }
  }
}

</style>
